import { render, staticRenderFns } from "./orderdetailsbox.vue?vue&type=template&id=34cbd11a&scoped=true"
import script from "./orderdetailsbox.vue?vue&type=script&lang=js"
export * from "./orderdetailsbox.vue?vue&type=script&lang=js"
import style0 from "./orderdetailsbox.vue?vue&type=style&index=0&id=34cbd11a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cbd11a",
  null
  
)

export default component.exports